import type KubernetesAppName from '~/constants/common/KubernetesAppName';

export default function getEnabledCookieName(appName: KubernetesAppName) {
  return `carvana-merch-${appName}`;
}
